import {
  IRequirementDefinitionDisplayUpdate,
  IRequirementDefinitionResponse,
  RequirementExpirationStrategy,
  RequirementReviewStrategy,
  RequirementVersionScope,
  RequirementVersionTransitionStrategy
} from "@wingspanhq/payments/dist/interfaces";
import { servicePayments } from "../servicePayments";

//TODO: remove
export interface IRequirementDefinitionUpdateRequest extends IRequirementDefinitionDisplayUpdate {
  reviewStrategy?: RequirementReviewStrategy;
  daysUntilEffective?: number;
  daysUntilExpiration?: number;
  expirationStrategy?: RequirementExpirationStrategy;
  expirationDays?: number;
  manualRenewalAllowed?: boolean;
  versionTransitionStrategy?: RequirementVersionTransitionStrategy;
  versionTransitionExpiresAt?: Date;
  versionScope?: RequirementVersionScope;
  dataSourceId?: string;
  versionNote?: string;
}

export const updateRequirementDefinition = async (
  id: string,
  payload: IRequirementDefinitionUpdateRequest
): Promise<IRequirementDefinitionResponse> => {
  const response = await servicePayments.patch(
    `/requirement-definition/${id}`,
    payload
  );
  return response.data;
};
